import { type IIcon } from '@/app/types/iconType'

export const Note = (props: Omit<IIcon, 'iconName'>) => {
    const { height = '20', width = '20', color = '#fff' } = props
    return (
        <svg width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M21 15L21 5C21 3.89543 20.1046 3 19 3L5 3C3.89543 3 3 3.89543 3 5L3 19C3 20.1046 3.89543 21 5 21L15 21M21 15V15.1716C21 15.702 20.7893 16.2107 20.4142 16.5858L16.5858 20.4142C16.2107 20.7893 15.702 21 15.1716 21H15M21 15L17 15C15.8954 15 15 15.8954 15 17L15 21M7 7L17 7M7 11L17 11M7 15L11 15'
                stroke={color}
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='2'
            />
        </svg>
    )
}
